import { useState, useEffect } from "react";
import { Link } from 'react-router-dom'
import { Form, Input, Button, Select } from "antd";
import styled from "styled-components";

import ServiceMaster from '../../service/_Master'
import ServiceAuth from '../../service/Auth'
import FormControl from "../../component/form/FormControl";

import moment from "moment";
import "moment/locale/th";
moment.locale("th");

const { Option } = Select;

const FormExtend = styled(FormControl)`
    
`;

export default function FormRegisterUser(props) {

    const [org, setOrg] = useState([])
    const [form] = Form.useForm();

    useEffect(() => {
        const init = async() => {
            let orgs = await ServiceMaster.getOrg()
            setOrg(orgs)
        }
        init()
        form.setFieldsValue({});
    }, [form]);

    const onFinish = async (values) => {
        let result = await ServiceAuth.register(values)
        if(result) window.location.href = "/"
    };

    const validateConfirmPassword = (rule, value, callback) =>
        value == form.getFieldValue("password")
            ? Promise.resolve()
            : Promise.reject(new Error("รหัสผ่านไม่ตรงกัน"));

    const formInput = () => {
        return (
            <>
                <Form.Item
                    name={["email"]}
                    className="form-item__email"
                    label="อีเมล"
                    rules={[{ required: true, type: "email" }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name={["orgId"]}
                    className="form-item__org-id"
                    label="หน่วยงาน/องค์กร"
                    rules={[{ required: true }]}
                >
                    <Select placeholder="กรุณาเลือก" allowClear>
                    <Option key={0} value={0}>หน่วยงาน/องค์กรอิสระ</Option>
                    {org.map((item) => (<Option key={item.id} value={item.id}>{item.disp_name}</Option>))};
                    </Select>
                </Form.Item>
                <Form.Item
                    name={["firstName"]}
                    className="form-item__first-name"
                    label="ชื่อ"
                    rules={[{ required: true }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name={["lastName"]}
                    className="form-item__last-name"
                    label="นามสกุล"
                    rules={[{ required: true }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name={["password"]}
                    className="form-item__password"
                    label="รหัสผ่าน"
                    rules={[{ required: true }]}
                >
                    <Input.Password />
                </Form.Item>
                <Form.Item
                    name={["confirmPassword"]}
                    className="form-item__confirm-password"
                    label="ยืนยันรหัสผ่าน"
                    dependencies={["password"]}
                    rules={[{ required: true }, { validator: validateConfirmPassword }]}
                >
                    <Input.Password />
                </Form.Item>
                <Form.Item
                    name={["tel"]}
                    className="form-item__tel"
                    label="เบอร์โทรศัพท์"
                    rules={[
                        { required: true },
                    ]}
                >
                    <Input
                        onChange={(e) => {
                            let value = e.target.value.replace(/[^0-9]+/g, "");
                            form.setFieldsValue({ tel: value });
                        }}
                    />
                </Form.Item>
                <Form.Item className="form-button">
                    <Button
                        className="form-item__btn-submit btn-primary"
                        htmlType="submit"
                    >
                        ยืนยัน
                    </Button>
                    <Button
                        className="form-item__btn-submit btn-secondary"
                    ><Link to="/">ยกเลิก</Link>
                    </Button>
                </Form.Item>
            </>
        );
    };

    return (
        <FormExtend
            name={"form-register-user"}
            column={2}
            inputs={formInput}
            onFinish={props.onFinish ? props.onFinish : onFinish}
            form={form}
            className={props.className ? props.className : ""}
        ></FormExtend>
    );
}
